import { StringEditor } from "@/react/features/globalization/components/StringEditor";
import React from "react";

export const numberEdit = (row, field, onChange) => (
  <StringEditor
    type="number"
    value={row[field]}
    onChange={(newText) => onChange(row, field, parseInt(newText))}
  />
);
